import { LangCodes } from './shared/enums/lang-codes.enum';
import { Component, HostListener, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'app-frontend-habana412';
  langSelected: string;
  routesArray: string[] = ["/landing", "/home", "/rooms", "/location", "/contact"];

  constructor(private translate: TranslateService,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.langSelected = localStorage.getItem("langSelected");
    if (this.langSelected != null) {
      translate.setDefaultLang(this.langSelected);
    } else {
      translate.setDefaultLang(LangCodes.spanish);
      localStorage.setItem("langSelected", LangCodes.spanish);
    }

    // renderer.listen('window', 'mousewheel', (event) => {

    //   //activo navigate scroll solo para desktop con una innerHeight que supere el alto maximo de la pagina
    //   //ademas lo deshablito si se esta viendo la modal de room
    //   if (window.innerHeight > 730 && window.innerWidth > 1200 && document.getElementsByClassName("customModalRoom").length == 0) {

    //     if (event.wheelDelta > 0) {

    //       let indexRoute: number = this.routesArray.indexOf(this.router.url)
    //       if (indexRoute >= 0) {
    //         let newRoute: string = this.routesArray[indexRoute - 1]
    //         if (newRoute != undefined) {
    //           this.router.navigate([newRoute])
    //         }
    //       }

    //     } else if (event.wheelDelta < 0) {

    //       let indexRoute: number = this.routesArray.indexOf(this.router.url)
    //       if (indexRoute >= 0) {
    //         let newRoute: string = this.routesArray[indexRoute + 1]
    //         if (newRoute != undefined) {
    //           this.router.navigate([newRoute])
    //         }
    //       }

    //     }

    //   }

    // });

  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  onActivate() {
    this.renderer.addClass(document.body, 'backgroundHome');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (window.innerWidth <= 992 && this.router.url != '/mobile') {
      this.router.navigate(['mobile']);
      //location.reload();
    } else if (window.innerWidth > 992 && this.router.url == '/mobile') {
      this.router.navigate(['landing']);
      setTimeout(() => {
        location.reload();
      }, 10);
    }
  }

}